var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50307 5.86081H5.00687V8.05861H6.50307V5.86081Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9917 5.86081H9.49548V8.05861H10.9917V5.86081Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99927 0C6.34661 0 5.00687 1.31199 5.00687 2.9304H2.01519L1.77704 10.8598C1.73495 12.2612 1.71391 12.9619 1.93365 13.5157C2.22665 14.254 2.81239 14.8447 3.55742 15.1532C4.11618 15.3846 4.83202 15.3846 6.26371 15.3846H9.73629C11.168 15.3846 11.8838 15.3846 12.4426 15.1532C13.1876 14.8447 13.7734 14.254 14.0663 13.5157C14.2861 12.9619 14.265 12.2612 14.223 10.8598L13.9848 2.9304H10.9917C10.9917 1.31199 9.65193 0 7.99927 0ZM7.99927 1.4652C7.17294 1.4652 6.50307 2.12119 6.50307 2.9304H9.49548C9.49548 2.12119 8.8256 1.4652 7.99927 1.4652ZM3.46804 4.3956L3.2726 10.9029C3.25094 11.6239 3.23776 12.0904 3.25219 12.4477C3.26611 12.7922 3.30373 12.9231 3.32825 12.9849C3.47475 13.3541 3.76762 13.6495 4.14013 13.8037C4.20248 13.8295 4.33503 13.8702 4.68628 13.894C5.05054 13.9186 5.52709 13.9194 6.26371 13.9194H9.73629C10.4729 13.9194 10.9495 13.9186 11.3137 13.894C11.665 13.8702 11.7975 13.8295 11.8599 13.8037C12.2324 13.6495 12.5253 13.3541 12.6717 12.9849C12.6963 12.9231 12.7339 12.7922 12.7478 12.4477C12.7622 12.0904 12.7491 11.6239 12.7274 10.9029L12.532 4.3956H3.46804Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.ca15f0822ed2bc61bc7641bdb948488b.svg";
export { ForwardRef as ReactComponent };